const cellLines = [
  'HeLa',
  'MCF-7',
  'HepG2',
  'A549',
  'SH-SY5Y',
  'U-2 OS',
  'Jurkat',
  'PC-3',
  'THP-1',
  'HCT 116',
  'A-431',
  'Caco-2',
  'HEK-293',
  'SK-N-MC',
  'RAW 264.7',
  'SW480',
  'MDA-MB-231',
  'HT-29',
  'K562',
  'MOLT-4',
  'SK-BR-3',
  'NIH/3T3',
  'MDCK',
  'CHO',
  'Raji',
  'H460',
  'LNCaP',
  'COS-7',
  'DLD-1'
];

export default cellLines;
